/* eslint-disable */
export default {
  'title': 'AdGroup',
  'type': 'AdGroup',
  'properties': {
    'CampaignId': {
      'type': 'Number',
      'nullable': false,
      'readonly': true
    },
    'CampaignName': {
      'type': 'String',
      'nullable': false,
      'readonly': true
    },
    'DeliveryStatus': {
      'type': 'String',
      'nullable': true,
      'readonly': true,
      'enum': ['CreditCardExpired', 'IOExceeded', 'PaymentInformationMissing', 'InvalidFinancialStatusOther', 'MigrationPaused', 'CampaignDeleted', 'CampaignBudgetPaused', 'ShoppingCampaignStoreNotFound', 'ShoppingCampaignNoOffersPresent', 'AdGroupExpired', 'AdGroupDraft', 'CamAssetRejected', 'CamAssetDeleted', 'EditorialRejected', 'EditorialUnderAppeal', 'EditorialPending', 'AssociationDeleted', 'CampaignUserPaused', 'AdGroupUserPaused', 'AdUserPaused', 'KeywordMatchTypeAdGroupMediumCombinationInvalid', 'KeywordUserPaused', 'NegativeKeywordConflicts', 'BidBelowFirstPageBid', 'EditorialApprovedLimited', 'Incomplete', 'BudgetSuggestions', 'GeoCodingIncomplete', 'ProductTargetUserPaused', 'AdExtensionNotPresent', 'AdExtensionDeleted', 'AdExtensionAssociationDeleted', 'StoreIdNotAssociated', 'ApplicationNotFound', 'ApplicationDestinationUrlMismatch', 'PendingMetadataSync', 'Eligible']
    },
    'NegativeKeywordCount': {
      'type': 'Number',
      'nullable': true,
      'readonly': true
    },
    'BiddingStrategy': {
      'type': 'String',
      'nullable': true,
      'enum': ['Manual', 'CPA']
    },
    'Id': {
      'type': 'Number',
      'nullable': false
    },
    'MakeAllChildrenInheritCashBackInfo': {
      'type': 'Boolean',
      'nullable': true
    },
    'Medium': {
      'type': 'String',
      'nullable': true,
      'readonly': true,
      'enum': ['Search', 'Content']
    },
    'Name': {
      'type': 'String',
      'nullable': false,
      'mergeEditable': false,
      'required': true,
      'aggregateType': 'count'
    },
    'NegativeKeywords': {
      'type': 'Object',
      'nullable': false
    },
    'NegativeSiteURLs': {
      'type': 'Object',
      'nullable': false
    },
    'Network': {
      'type': 'String',
      'nullable': true,
      'enum': ['BingYahooAndSearchPartners', 'BingYahooOnly', 'SearchPartnersOnly']
    },
    'OptimizationTarget': {
      'type': 'Number',
      'nullable': true
    },
    'PricingModel': {
      'type': 'String',
      'nullable': true,
      'enum': ['CPC', 'CPM']
    },
    'PublisherCountries': {
      'type': 'Object',
      'nullable': false
    },
    'StartDate': {
      'type': 'DateTime',
      'nullable': true
    },
    'Status': {
      'type': 'String',
      'nullable': true,
      'enum': ['CampaignUserPaused', 'CampaignBudgetPaused', 'CampaignBudgetUserPaused', 'Draft', 'Active', 'Deleted', 'Paused', 'Expired']
    },
    'Timestamp': {
      'type': 'Object',
      'nullable': false
    }
  }
};

